export default "__VITE_ASSET__BNL05gLV__"